
import Vue from "vue";
export default Vue.extend({
  props: {
    noTitle: {
      type: Boolean,
      default: false,
    },
  },
});
